import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareAuthCheckData, ShareLinkResponse } from '../../types';
import type { ShareIdApi } from '../share-id-api';

@injectable()
export class ShareIdApiImpl extends PsHttpService implements ShareIdApi {
  get options() {
    return {
      baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  getShareIdForGuest(inputData: ShareAuthCheckData) {
    return this.post<PatSnapCommonResponseData<ShareLinkResponse>>({
      url: '/share/create',
      data: inputData,
    }).then((res) => {
      return res.data as ShareLinkResponse;
    });
  }

  getShareId(inputData: ShareAuthCheckData) {
    return this.post<PatSnapCommonResponseData<ShareLinkResponse>>({
      url: '/secure-share/create',
      data: inputData,
    }).then((res) => {
      return res.data as ShareLinkResponse;
    });
  }
}
